export class UserType {
    public static SystemAdmin:String = 'SYSTEMADMINISTRATOR';
    public static CentreAdmin:String = 'CENTREADMINISTRATOR';
    public static CentreUser:String = 'CENTREUSER';
    public static Practitioner:String = 'PRACTITIONER';
    public static Nurse:String = 'NURSE';
}

export const AccessUrl = [
    {url: '/add-patient', permission: 'page.addpatient'},
    {url: '/new-feed', permission: 'page.newfeed'},
    {url: '/request-appointment', permission: 'page.requestappointment'},
    {url: '/view-schedule', permission: 'page.viewschedule'},
    {url: '/administered', permission: 'page.administered'},
    {url: '/change-password', permission: 'page.changepassword'},
    {url: '/create-password', permission: 'page.createpassword'},
    {url: '/logout', permission: 'page.logout'},
];



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/shared/constants/permission.ts